module.exports = __webpack_public_path__ + "static/imagem_3-79dfea9eaac79c7445665703211b8505.jpeg";